import React from "react";

import { useSearchspringContext } from "@app/providers/searchspring";
import { useSearchspringSort } from "@app/hooks/use-searchspring-sort";

import { Icon } from "@app/components/icon";

export function ResultSort({ name = "sort" }) {
  const { refine } = useSearchspringContext();
  const { sorts, activeSortLabel } = useSearchspringSort();

  return (
    <div x-data="dropdown" className="group relative w-full">
      <button
        x-bind="open"
        className="bg-neutrals-grey-5 flex w-full items-center justify-between gap-2 rounded p-3 hover:bg-neutrals-grey-4"
      >
        <p className="text-body-sm">
          <span className="text-neutrals-grey-2">Sort By: </span>
          <span>{activeSortLabel}</span>
        </p>
        <Icon id="ChevronDown" className="size-3" />
      </button>
      <div x-bind="container" className="right-0 top-full pt-2">
        <div
          x-bind="content"
          className="flex w-52 flex-col rounded border border-neutrals-grey-4 bg-neutrals-white p-1 drop-shadow-xl"
        >
          {sorts?.map((sort) => (
            <div key={sort.value} className="whitespace-nowrap px-3 py-2">
              <button
                id={`sort__${sort.value}`}
                value={sort.value}
                name={name}
                onClick={() => refine("sort", sort.value)}
                className="flex h-6 w-full items-center whitespace-nowrap"
              >
                {sort.label}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
